import React, { useEffect, useState } from "react";
import { Months, startYear } from "../../core/constants/common";
import { withTranslation } from "react-i18next";

const MonthlyPeriodSelector = ({
	t,
	defaultPeriod,
	minPeriod,
	valueChangeCallback,
  type
}) => {
	const defaultYear = defaultPeriod ? defaultPeriod.split('-')[0] : null;
	const defaultMonth = defaultPeriod ? defaultPeriod.split('-')[1] : null;
	const minYear = minPeriod ? minPeriod.split('-')[0] : null;
	const minMonth = minPeriod ? minPeriod.split('-')[1] : null;

  const [year, setYear] = useState(defaultYear ? defaultYear : new Date().getFullYear());
  const [month, setMonth] = useState(defaultMonth ? defaultMonth : '01');

	const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1;
	const endYear = currentYear + 2;
  const yearOptions = [];
  for (let i = endYear; i >= startYear; i--) {
    yearOptions.push(
      <option value={i} key={i} disabled={i < currentYear || i < minYear}>
        {i}
      </option>
    );
  }  
	const monthOptions = Months({ t });

  useEffect(() => {
    if (defaultPeriod) {
      const newYear = defaultYear ? defaultYear : new Date().getFullYear();
      const newMonth = defaultMonth ? defaultMonth : '01';
      setYear(newYear);
      setMonth(newMonth);
    }
  }, [defaultPeriod]);

  return (
    <div className="row ReportingPeriod-row">
      <div className="col-lg-6 col-md-6">
        <select
          className="form-select"
          disabled={type === 'ORG_CALENDAR'}
          onChange={(e) => {
            setYear(e.target.value);
            valueChangeCallback({
							year: e.target.value,
							month: month
						});
          }}
          value={year}>
          {yearOptions}
        </select>
      </div>
      <div className="col-lg-6 col-md-6">
        <select
          className="form-select"
          required
          value={month}
          disabled={type === 'ORG_CALENDAR'}
          onChange={(e) => {
            setMonth(e.target.value);
            valueChangeCallback({
							year: year,
							month: e.target.value
						});
          }}>
          {monthOptions.map((item) => (
            <option
              value={item.value}
              key={item.value}
              disabled={year === minYear && +(item.value) < +(minMonth)}>
              {item.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default withTranslation()(MonthlyPeriodSelector);
